<template>
  <div style="width: 100%;">
    <!-- 列表页面 -->
    <div v-if="isShow" class="project-list" style="overflow: scroll;height:100%;">
      <div class="list-header">
          <span></span>
          <CustomTool style="width:120px;" :column_mapper="column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="false" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="exportExcel"/>
      </div>
      <div style="width: calc(100% - 0px)">
        <!-- 表单主体内容 -->
        <div style="height: 100%;width:100%;box-sizing: border-box;padding:0px 0px;overflow: scroll;background:white;">
          <custom-table
              ref="mytable"
              table-id="client-project-table"
              :project-list-dl="tableData.projectList"
              :show-coloums-dl="tableData.showColoums"
              :column_mapper="tableData.column_mapper"
              @current-change="currentChange"
              @row-click="rowClick"
              :sort-column-name-dl="tableData.sortColumnName"
              :sort-column-order-dl="tableData.sortColumnOrder"

              :totalnums-dl="tableData.totalnums"
              :pagesize-dl="tableData.pagesize"
              :page-number-dl="tableData.pageNumber"

              :fixed-columns="tableData.fixedList"
              :fixed-right-columns="tableData.fixedRightList"

              :disableDrag="true"
              :sortable="false"
              :sortableColumns="tableData.sortableColumns"

              :pagination="tableData.pagination"

              :is-loading-dl="tableData.detailLoading"
              :use-virtual="false"
              :row-hegit="0"

              :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
              :padding="'0px'"
              :custom-column-width="tableData.customColumnWidth"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import customTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import { getClientProjectList, exportClientProjectList } from "@/api/api";

export default {
  name: "ProjectList",
  components:{
    customTable,
    CustomTool,
    getClientProjectList
  },
  props: ["clientName"],
  data(){
    return {
      isShow:true, //是否展示列表，true为展示客户列表，false会展示详情页面
      // 表格所需数据
      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: [],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true
      },
      filterRequestData:{},
      // 过滤器属性
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      filterArchiveData:{
        queryCond: []
      },
      // 控制新增用户按钮
      showAddClient:false,

      column_mapper: {
        "project:project_id": "订单ID:varchar",
        "project:project_name": "订单名称:varchar",
        "time:first_quotation_time": "报价日期:time",
        "amount:quotation": "报价:decimal",
        "amount:income": "收入:decimal",
        "amount:invoice": "开票:decimal",
        "amount:collection": "收款:decimal",
        "status:project_status": "执行状态:varchar",
        "project:quotation_type": "计价类型:varchar",
        "dept:responsible_p_dept": "业务部门:varchar",
        "dept:responsible_s_dept": "业务组:varchar",
        "member:project_manager": "项目经理:varchar",
        "dept:sales_s_dept": "销售组:varchar",
        "member:account_manager": "客户经理:varchar"
      }
    }
  },
  mounted() {
    this.refresh()
  },
  methods:{
    // 获取分类详情
      getSelection(tab){
        this.tab = tab
        const content = this.filterContent
        const filter = {
            "columnName": "client_name",
            "filter": "eq",
            "columnValue": this.clientName
          }
        if (content.hasOwnProperty('queryCond')){
          var tmp = 0
          for (var i in content['queryCond']) {
            if (content['queryCond'][i]['columnName'] == 'client_name') {
              content['queryCond'][i]['filter'] = "eq"
              content['queryCond'][i]["columnValue"] = this.clientName
              tmp = 1
            }
          }
          if (tmp == 0) {
            content['queryCond'].push(filter)
          }
        }else{
          content['queryCond'] = [filter]
        }
        Object.assign(this.filterContent,content)
        this.refresh(true)
      },

      filterContentChange(content){
        Object.assign(this.filterContent,content)
        this.refresh(true)
      },
      /**
       * 表格某行点击
       * @param e 点击item数据
       * 点击之后列表页面隐藏，详情页面展示
       */

      rowClick(e) {
        this.$store.commit("setProjectId", e["project_id"]);
        this.$store.commit("setProjectInfo", {
          projectId: e["project_id"],
          projectName: e["project_name"],
          accu: 0
        })
      },

    currentChange(e) {
        console.log('currentChange',e)
        this.tableData.pageNumber = e;
        this.refresh(false)
      },

      async getData(resetPage=false){
        var tmp = 0
        if(resetPage){
          this.tableData.pageNumber = 1
        }
        const filter = {
            "columnName": "client:client_name",
            "filter": "eq",
            "columnValue": this.clientName
          }
        if (this.filterContent.hasOwnProperty('queryCond')){
          var tmp = 0
          for (var i in this.filterContent['queryCond']) {
            if (this.filterContent['queryCond'][i]['columnName'] == 'client_name') {
              this.filterContent['queryCond'][i]['filter'] = "eq"
              this.filterContent['queryCond'][i]["columnValue"] = this.clientName
              tmp = 1
            }
          }
          if (tmp == 0) {
            this.filterContent['queryCond'].push(filter)
          }
        }else{
          this.filterContent['queryCond'] = [filter]
        }
        this.filterRequestData = {
          division:this.currentSelectLeftItemKey,
          pagiInfo: {
            currentPage: this.tableData.pageNumber,
            pagesize: this.tableData.pagesize
          },
          ...this.filterContent
        }
        let postData = this.filterRequestData
        console.log('postData', postData)
        let res = await getClientProjectList(postData)
        let resData = res
        // console.log("resData", resData)
        const {respData: {cols_mapper, data , columns_list, totalnums}} = resData
        // console.log('返回结果', resData,cols_mapper,data,columns_list)
        this.tableData.column_mapper = cols_mapper
        this.tableData.projectList = data
        this.tableData.totalnums =  totalnums
        this.tableData.showColoums = columns_list
        // console.log('this.tableData.showColoums',this.tableData.showColoums )
        this.$nextTick(() => {
          this.tableData.detailLoading = false
        })

      },

      async refresh(resetPage=false){
        this.tableData.detailLoading = true
        await this.getData(resetPage)
      },

      async exportExcel() {
        let param = this.filterRequestData
        let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
        try {
          let {data} = await exportClientProjectList(param)
          loadingInstance.close();
          const blob = new Blob([data])
          var date = new Date()
          let Y = date.getFullYear().toString()
          let M = (date.getMonth() + 1).toString().padStart(2, "0")
          let D = date.getDate().toString().padStart(2, "0")
          let H = date.getHours().toString().padStart(2, "0")
          let m = date.getMinutes().toString().padStart(2, "0")
          let s = date.getSeconds().toString().padStart(2, "0")
          let fileName = '客户订单-' + Y + M + D + H + m + s + ".xlsx"

          const link = document.createElement('a')
          link.download = fileName
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        } catch(err) {
            loadingInstance.close();
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
            if (issafariBrowser) {
            this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
            } else {
            this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
            }
        }
      }
  }
}
</script>

<style scoped>
  .list-header{
    width:calc(100% - 0px);
    display: flex;
    justify-content: space-between;
  }
</style>